module.exports = __webpack_public_path__ + "static/media/clash.7d8c59a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clash.svg
// module id = 138
// module chunks = 0